module.exports = __webpack_public_path__ + "static/media/affirm.f372c550.svg";